import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Observable, OperatorFunction, catchError, from, isObservable, throwError } from 'rxjs';

export function isHttpError(err: unknown, statusCode: HttpStatusCode): err is HttpErrorResponse {
  return err instanceof HttpErrorResponse && err.status === statusCode;
}

/**
 * RxJS operator function (for use with pipe) that handles HttpErrorResponses with a specific HTTP status code.
 * For example, can be used to add custom logic/error message for a 409 Conflict error, while allowing anything other than 409s to be handled normally.
 */
export function catchHttpError<TIn, TOut = TIn>(
  statusCode: HttpStatusCode,
  handle: (err: HttpErrorResponse) => TOut | PromiseLike<TOut> | Observable<TOut>): OperatorFunction<TIn, TIn | TOut> {
  return catchError((err: unknown) => {
    if (!isHttpError(err, statusCode)) {
      return throwError(() => err);
    }

    const result = handle(err);
    return isObservable(result) ? result : from(Promise.resolve(result));
  });
}
